import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
  variant?: "default" | "compact";
}

export default function ArticleCard({ article, variant = "default" }: ArticleCardProps) {
  const isCompact = variant === "compact";

  return (
    <article
      className={[
        "group bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors cursor-pointer",
        isCompact ? "flex gap-4 p-3" : "flex flex-col",
      ].join(" ")}
    >
      <Link
        to={`/article/${article.id}`}
        className={[
          "block overflow-hidden bg-background-100",
          isCompact ? "w-28 h-24 shrink-0 rounded-md" : "w-full aspect-[4/3]",
        ].join(" ")}
      >
        <img
          src={article.cover}
          alt={article.coverAlt}
          title={`${article.title} - 选美吃瓜`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      <div className={isCompact ? "flex flex-col justify-between py-0.5" : "p-5 flex flex-col flex-1"}>
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 text-[11px] rounded bg-secondary-100 text-secondary-900">
              {article.category}
            </span>
            {!isCompact && <span className="text-[11px] text-foreground-400">{article.date}</span>}
          </div>
          <h3
            className={[
              "font-heading font-bold text-foreground-950 group-hover:text-primary-700 transition-colors",
              isCompact ? "text-sm leading-snug line-clamp-2" : "text-lg leading-snug",
            ].join(" ")}
          >
            <Link to={`/article/${article.id}`}>{article.title}</Link>
          </h3>
          {!isCompact && (
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{article.excerpt}</p>
          )}
        </div>

        {!isCompact && (
          <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line" />
              {article.author}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" />
              {article.readTime}
            </span>
          </div>
        )}
      </div>
    </article>
  );
}